import React from 'react';

import { SizedBox } from '@/components/SizedBox';
import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { designSystem } from '@/styles/styles';

export const PromoProgressDetailsSkeleton = () => {
    return (
        <Box paddingTop={'s32'}>
            <LoadingSkeleton skeletonColor={designSystem.colors.neutral300} height={28} borderRadius={'r16'} />
            <SizedBox value={20} />
            <LoadingSkeleton skeletonColor={designSystem.colors.neutral300} height={28} borderRadius={'r16'} />
            <SizedBox value={16} />
            <LoadingSkeleton skeletonColor={designSystem.colors.neutral300} height={28} borderRadius={'r16'} />
            <SizedBox value={16} />
            <LoadingSkeleton skeletonColor={designSystem.colors.neutral300} height={28} borderRadius={'r16'} />
            <SizedBox value={36} />
        </Box>
    );
};
